// @vendors
import Context from "context/appContext";
import { useState, useEffect, useContext } from "react"

// @components

// @styles 
import './styles.scss'


export default function BigSwitch({ info }) {
    const { dataForm: { formResponses }, setModality } = useContext(Context);
    const [isClassActive, setClassActive] = useState(true);
    const [defaultClass, setDefaultClass] = useState('default');
    const [options, setOptions] = useState(null);
    const [values, setValues] = useState(null);

    useEffect(() => {
        setOptions(info && info.values);
        setValues(info && info.customDefaultValue);
        const defaultValue = info && info.values[0]?.value;
        setModality(defaultValue);
        setValue(defaultValue);
    }, []);

    const onClick = (value) => {
        setValue(value)
        setClassActive(!isClassActive);
        setModality(value);
        setDefaultClass('active-btn-left');
    };
    const setValue = (value) => {
        info.value = value;
        const index = formResponses.findIndex(x => x.key === info.key);
        index != -1 ? formResponses[index].value = value : formResponses.push(info);
    }

    return options && options.length === 2 && (
        <div className='switch__container'>
            <div className='switch__container__buttons'>
                <button className={`switch__container__buttons-btn ${isClassActive && defaultClass}`}
                    disabled={isClassActive}
                    onClick={() => onClick(options[0]?.value)}>
                    <span>{options[0]?.label}</span>
                </button>
                <button className={`switch__container__buttons-btn ${!isClassActive ? 'active-btn-right' : ''}`}
                    disabled={!isClassActive}
                    onClick={() => onClick(options[1]?.value)}>
                    <span>{options[1]?.label}</span>
                </button>
            </div>
            <div className='switch__container__description'>{values[isClassActive ? options[0].value : options[1].value]?.descripcion}</div>
        </div>
    )
}